import { render, staticRenderFns } from "./UiSelectFileButton.vue?vue&type=template&id=7dd9564a"
import script from "./UiSelectFileButton.vue?vue&type=script&lang=ts"
export * from "./UiSelectFileButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports